import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const navigate = useNavigate();

  const [userDetails, setUser] = useState(() => {
    const storedUser = localStorage.getItem('userC');
    if (storedUser) {
      try {
        const userObj = JSON.parse(storedUser);
        return {
          user_id: userObj.user_id || '',
          username: userObj.username || '',
          first_name: '',
          middle_name: '',
          last_name: '',
          email: '',
          phone: '',
          dob: '',
          house_number: '',
          town: '',
          city: '',
          county: '',
          post_code: '',
          country: '',
          picture: '',
        };
      } catch {
        return {
          user_id: '',
          username: '',
          first_name: '',
          middle_name: '',
          last_name: '',
          email: '',
          phone: '',
          dob: '',
          house_number: '',
          town: '',
          city: '',
          county: '',
          post_code: '',
          country: '',
          picture: '',
        };
      }
    }
    return {
      user_id: '',
      username: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      email: '',
      phone: '',
      dob: '',
      house_number: '',
      town: '',
      city: '',
      county: '',
      post_code: '',
      country: '',
      picture: '',
    };
  });

  const [originalUserDetails, setOriginalUserDetails] = useState(null); // ← added
  const [isEditing, setIsEditing] = useState(false);
  const [preview, setPreview] = useState('');

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn || !userDetails.user_id) {
      navigate('/login');
    } else {
      fetchUserProfile(userDetails.user_id);
    }
  }, [navigate, userDetails.user_id]);

  const fetchUserProfile = async (user_id) => {
    try {
      const res = await fetch('https://xcelitsolutions.co.uk/get_user_profile.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id }),
      });
      const data = await res.json();
      if (data.status === 'success') {
        const fullProfile = { ...userDetails, ...data.user };
        setUser(fullProfile);
        setOriginalUserDetails(fullProfile); // ← added
        setPreview(data.user.picture || '');
      } else {
        alert(data.message || 'Failed to fetch profile');
      }
    } catch {
      alert('Error fetching profile');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('profile_picture', file);

      try {
        const res = await fetch('https://xcelitsolutions.co.uk/upload_profile_picture.php', {
          method: 'POST',
          body: formData,
        });

        const data = await res.json();
        if (data.status === 'success') {
          setPreview(data.url);
          setUser(prev => ({ ...prev, picture: data.url }));
        } else {
          alert('Failed to upload image');
        }
      } catch {
        alert('Error uploading image');
      }
    }
  };

  const handleSave = async () => {
    try {
      const res = await fetch('https://xcelitsolutions.co.uk/save_user_profile.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userDetails),
      });
      const data = await res.json();
      if (data.status === 'success') {
        alert('Profile updated!');
        setIsEditing(false);
        localStorage.setItem('userC', JSON.stringify(userDetails));
        setOriginalUserDetails(userDetails); // ← update after save
      } else {
        alert(data.message || 'Failed to update profile');
      }
    } catch {
      alert('Error saving profile');
    }
  };

  const handleCancel = () => {
    if (originalUserDetails) {
      setUser(originalUserDetails);
      setPreview(originalUserDetails.picture || '');
    }
    setIsEditing(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: 'auto', padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h2>My Profile</h2>
        {!isEditing && <button onClick={() => setIsEditing(true)}>Edit Profile</button>}
      </div>

      <div style={{ textAlign: 'center' }}>
        <img
          src={preview || 'https://via.placeholder.com/120'}
          alt="Profile"
          style={{ width: 150, height: 150, borderRadius: '10%' }}
        />
        {isEditing && (
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ marginTop: 10 }}
          />
        )}
      </div>

      <form onSubmit={(e) => e.preventDefault()} style={{ marginTop: 20 }}>
        {/* your input fields (username, email, first_name, etc.) stay the same */}
        {/* skipped for brevity - reuse your input code exactly here */}
        
        
        <label>Username</label>
        <input
          name="username"
          value={userDetails.username}
          onChange={handleChange}
          disabled
          style={{ width: '100%', marginBottom: 10 }}
        />
 <label>Email</label>
        <input
          type="email"
          name="email"
          value={userDetails.email}
          onChange={handleChange}
          disabled
          style={{ width: '100%', marginBottom: 10 }}
        />
        <label>First Name</label>
        <input
          name="first_name"
          value={userDetails.first_name}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Middle Name</label>
        <input
          name="middle_name"
          value={userDetails.middle_name}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Last Name</label>
        <input
          name="last_name"
          value={userDetails.last_name}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Date of Birth</label>
        <input
          type="date"
          name="dob"
          value={userDetails.dob}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

       

        <label>Phone</label>
        <input
          name="phone"
          value={userDetails.phone}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>House Number</label>
        <input
          name="house_number"
          value={userDetails.house_number}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Town</label>
        <input
          name="town"
          value={userDetails.town}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>City</label>
        <input
          name="city"
          value={userDetails.city}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>County</label>
        <input
          name="county"
          value={userDetails.county}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Post Code</label>
        <input
          name="post_code"
          value={userDetails.post_code}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        <label>Country</label>
        <input
          name="country"
          value={userDetails.country}
          onChange={handleChange}
          disabled={!isEditing}
          style={{ width: '100%', marginBottom: 10 }}
        />

        {isEditing && (
          <div style={{ marginTop: 20 }}>
            <button onClick={handleSave} style={{ marginRight: 10 }}>
              Save Changes
            </button>
            <button onClick={handleCancel}>Cancel</button> {/* ← updated */}
          </div>
        )}
      </form>
    </div>
  );
}

export default Profile;
